import clsx from 'clsx';
import React, { useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeyboardShortcutListeners } from '../../../a11y/shortcuts/hooks/useKeyboardShortcutListeners';
import { TabProps } from '../../interfaces/secondarySidebar';
import { SecondarySidebarItem } from '../secondary-sidebar-item/SecondarySidebarItem';

export function SecondarySidebar({
  tabs,
  forceExpanded = false,
  topSpacing = 7,
  expandThreshold = 1440
}: {
  tabs: TabProps[];
  forceExpanded?: boolean;
  topSpacing?: number;
  expandThreshold?: number;
}) {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  useKeyboardShortcutListeners(
    tabs
      .filter(tab => !tab.hidden)
      .reduce((bindings, tab) => {
        if (!tab.shortcut) {
          return bindings;
        }

        return {
          ...bindings,
          [tab.shortcut]: (event: KeyboardEvent) => {
            event.preventDefault();
            navigate(tab.path);
          }
        };
      }, {}),
    {
      priority: 0,
      terminal: 'match'
    }
  );

  useLayoutEffect(() => {
    const onResize = () => {
      if (forceExpanded) {
        setExpanded(true);
        return;
      }

      const screenWidth = document.body.getBoundingClientRect().width;
      if (screenWidth >= expandThreshold) {
        setExpanded(true);
      } else {
        setExpanded(false);
      }
    };

    onResize();

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div className={`tab-nav-wrapper pt-${topSpacing} border-right`}>
      <ul className={clsx('tab-nav tab-nav-vertical text-transform-none', expanded && 'expanded')}>
        {tabs
          .filter(tab => !tab.hidden)
          .map((tab, index) => (
            <li key={index}>
              <SecondarySidebarItem key={index} tab={tab} expanded={expanded} />
            </li>
          ))}
      </ul>
    </div>
  );
}
